export const Language = [
  'FRENCH',
  'ENGLISH'
]
